let mobilemodal = document.getElementById("Details-menu-drawer-container");
let modal = document.getElementById("currency-switcher-pop");

// Get the button that opens the modal
let btn = document.getElementById("myBtn");
let closeBtn = document.querySelectorAll(".close");
let changeCountryBtn = document.getElementById("changeCountryBtn");
let backBtn = document.getElementById("backBtn");
let continueBtn = document.getElementById("continueBtn");
let continueStoreBtn = document.getElementById("continueStoreBtn");

let screen1 = document.getElementById("screen1");
let screen2 = document.getElementById("screen2");

document.querySelectorAll(".disclosure__button").forEach((button) => {
  button.addEventListener("click", function () {
    modal.style.display = "block";
    screen1.style.display = "none";
    screen2.style.display = "block";
    document.body.classList.add("overflow-hidden");
  });
});

closeBtn.forEach((button) => {
  button.addEventListener("click", function () {
    modal.style.display = "none";
    localStorage.setItem("popupshown", true);
    document.body.classList.remove("overflow-hidden");
  });
});

continueStoreBtn.addEventListener("click", function () {
  modal.style.display = "none";
  localStorage.setItem("popupshown", true);
  document.body.classList.remove("overflow-hidden");
});

window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
    document.body.classList.remove("overflow-hidden");
  }
};

changeCountryBtn.onclick = function () {
  screen1.style.display = "none";
  screen2.style.display = "block";
};

backBtn.onclick = function (event) {
  event.preventDefault();
  screen2.style.display = "none";
  screen1.style.display = "block";
};

//Continue button functionality
continueBtn.onclick = function (event) {
  localStorage.setItem("popupshown", true);
  const form = this.querySelector("form");
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
};

document.addEventListener("DOMContentLoaded", function () {
  fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then((res) => res.json())
    .then((r) => {
      var countryWrapper = document.querySelector("[data-geo-country-wrapper]");
      if (countryWrapper) {
        countryWrapper.innerHTML = countryWrapper.innerHTML.replace(
          "{{ country_name }}",
          r.detected_values.country.name
        );
        if (
          !localStorage.getItem("popupshown") &&
          r.detected_values.country.handle.toLowerCase() !== "gb"
        ) {
          setTimeout(function () {
            modal.style.display = "block";
            document.body.classList.add("overflow-hidden");
          }, 1000);
        }
      }
    })
    .catch((error) => console.error("Error fetching data:", error));

  const selectBox = document.getElementById("country-select");
  const floatingLabel = document.getElementById("floatingLabel");
  let isDropdownOpen = false;

  if (selectBox) {
    selectBox.addEventListener("mousedown", function () {
      floatingLabel.classList.remove("hidden");
    });

    selectBox.addEventListener("focus", function () {
      floatingLabel.classList.remove("hidden");
    });

    selectBox.addEventListener("click", function () {
      isDropdownOpen = !isDropdownOpen;
      if (isDropdownOpen) {
        floatingLabel.classList.remove("hidden");
      } else {
        floatingLabel.classList.add("hidden");
      }
    });

    selectBox.addEventListener("blur", function () {
      isDropdownOpen = false;
      floatingLabel.classList.add("hidden");
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  let backBtn = document.getElementById("backBtn");
  let modal = document.getElementById("currency-switcher-pop");
  let mobilemodal = document.getElementById("Details-menu-drawer-container");
  let triggeredByDisclosureButton = false;

  document.querySelectorAll(".disclosure__button").forEach((button) => {
    button.addEventListener('click', function() {
      triggeredByDisclosureButton = true;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (window.innerWidth <= 768)) {
        modal.style.display = 'block';
      }
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function() {
      if (triggeredByDisclosureButton) {
        modal.style.display = 'none';
        triggeredByDisclosureButton = false;
        document.body.classList.remove("overflow-hidden");
      }
    });
  }

  modal.addEventListener('click', function() {
    handleModalInteraction();
  });

  modal.addEventListener('mouseover', function() {
    handleModalInteraction();
  });

  document.querySelectorAll('.footer__localizaton--country .disclosure__button').forEach(button => {
    button.addEventListener('click', function() {
      triggeredByDisclosureButton = false;
      const modal = document.getElementById('mobilemodal');
      if (modal) {
        modal.removeAttribute('open');
      }
    });
  });

  function handleModalInteraction() {
    if (triggeredByDisclosureButton) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (window.innerWidth <= 768)) {
        mobilemodal.setAttribute("open", "");
      }
    }
  }
});